import { observable, action, decorate, configure, toJS } from 'mobx';
import {
  API_PROXYBID_GET_BYAUCTION_ENDPOINT,
  API_PROXYBID_UPDATE_ENDPOINT,
  API_PROXYBID_DELETE_ENDPOINT,
} from '../shared/constants';
import { loadData } from './utils';

configure({ enforceActions: 'always' });

class ProxyBidsStore {
  constructor() {
    this.initializeProxyBidsList();
  }

  initializeProxyBidsList = () => {
    this.isLoading = true;
    this.proxyBids = [];
    this.totalItems = 0;
  };

  setProperty = (key, value) => {
    this[key] = value;
  };

  getProperty = (key) => {
    return this[key];
  };

  processData = (key, { data, totalItems }) => {
    this.setProperty(key, toJS(data));
    this.setProperty('totalItems', totalItems);
    this.setProperty('isLoading', false);
  };

  loadProxyBids = async (
    auctionID,
    pageNumber,
    pageSize,
    searchText,
    sortColumn,
    sortDirection,
  ) => {
    if (!auctionID) {
      return;
    }

    const params = {
      auctionID,
      pageNumber,
      pageSize,
      searchParams: searchText,
      sortBy: sortColumn,
      sortDirection,
    };

    this.isLoading = true;

    loadData(params, API_PROXYBID_GET_BYAUCTION_ENDPOINT).then((res) => {
      const {
        data: {
          pagedProxyBids: { proxyBids, totalItems },
        },
      } = res;
      this.processData('proxyBids', {
        data: proxyBids,
        totalItems: totalItems,
      });
    });
  };

  updateProxyBid = async (args) => {
    if (!args.proxyBidID) {
      return;
    }
    const params = { ...args };
    const res = await loadData(params, API_PROXYBID_UPDATE_ENDPOINT);
    const results = {
      newProxyBid: args.proxyBid,
      result: { message: res.data.message, success: res.data.success },
    };
    return results;
  };

  deleteProxyBid = async (args) => {
    if (!args.proxyBidID) {
      return;
    }
    const params = { ...args };
    const res = await loadData(params, API_PROXYBID_DELETE_ENDPOINT);
    const results = {
      result: { message: res.data.message, success: res.data.success },
    };
    return results;
  };
}

decorate(ProxyBidsStore, {
  getProperty: action,
  initializeProxyBidsList: action,
  isLoading: observable,
  loadProxyBids: action,
  processData: action,
  proxyBids: observable,
  setData: action,
  setProperty: action,
  totalItems: observable,
  updateProxyBid: action,
  deleteProxyBid: action,
});

export default ProxyBidsStore;
